import dataProvider, { generateFilter } from "@refinedev/simple-rest";
import queryString from "query-string";
import { API_URL } from "@/constants";
import axiosInstance from "../services/api";
import { DataProvider } from "@refinedev/core";

const { stringify } = queryString;
const simpleRestProvider = dataProvider(API_URL, axiosInstance);

export const myDataProvider: DataProvider = {
  ...simpleRestProvider,
  getList: async ({
    resource,
    pagination,
    meta,
    filters = [],
    sorters = [],
  }) => {
    const url = `${API_URL}/${resource}`;
    const { current = 1, pageSize = 10 } = pagination ?? {};
    const hasServerPagination = pagination?.mode === "server";

    type Query =
      | {
          size: number;
          page: number;
        }
      | {
          continue_index: string;
        };

    let query: Query = {
      size: pageSize,
      page: current,
    };

    // for cursor based pagination
    // cf https://refine.dev/docs/data/hooks/use-infinite-list/#how-to-use-cursor-based-pagination
    if (meta.cursor && pagination?.current) {
      query = {
        continue_index: String(pagination?.current),
      };
    }

    const queryFilters = generateFilter(filters);
    const querySorters: any = {};
    if (sorters.length) {
      querySorters.sort_by = sorters[0].field;
      querySorters.sort_order = sorters[0].order.toUpperCase(); // "ASC" or "DESC"
    }

    const requestUrl = hasServerPagination
      ? url.includes("?")
        ? `${url}&${stringify({ ...query, ...queryFilters, ...querySorters })}`
        : `${url}?${stringify({ ...query, ...queryFilters, ...querySorters })}`
      : url;

    const response = await axiosInstance.get(requestUrl);
    const { data, headers } = response;
    const total = +headers["x-total-count"];

    if (data?.pagination && data?.items) {
      const { total_results, page, per_page } = data.pagination || {};
      return {
        data: data.items,
        total: total_results,
        currentPage: page,
        pageSize: per_page,
      };
    }
    return {
      data,
      currentPage: current,
      total,
      cursor: {
        next: data?.continue_index,
      },
    };
  },
  update: async ({ resource, id, variables, meta }) => {
    const method: "patch" | "put" = ["patch", "put"].includes(meta?.method)
      ? meta.method
      : "patch";

    const params = (meta?.urlParams as URLSearchParams)?.toString() ?? "";

    const url = `${API_URL}/${resource}/${id}?${params}`;

    const { data } = await axiosInstance[method](url, variables);

    return {
      data,
    };
  },
};
